/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {UiScrollComponent as ɵa} from './src/ui-scroll.component';